import React from 'react'
import styled from "styled-components"
import Samaad from './Images/Sama-ad.jpeg'
import Courage from './Images/Courage.jpeg'
import Lase from './Images/Lase.jpeg'
import Bolu from './Images/Bolu.PNG'
import IBK from './Images/Awosika Ibukunoluwa.jpeg'
import IK from './Images/Ikenna.jpeg'
import Ifeanyi from './Images/Ifeanyi.jpeg'
import Ola from './Images/Alabi olaoluwa.jpeg'


function Lionhearts() {
  return (
    <div>
            <h1>Lionhearts</h1>
            <h3>OWNER: Adebayo </h3>
            <br/>
            <Div>
                <div><Img src={Lase}/> Lase</div><br/>
                <div><Img src={Samaad}/> Momoh Sama-ad </div><br/>
                <div><Img src={Courage}/> Courage</div><br/>
                <div><Img src={Bolu}/> Bolu</div><br/>
                <div><Img src={IBK}/> IBK</div><br/>
                <div><Img src={IK}/> IK</div><br/>
                <div><Img src={Ifeanyi}/> Ifeanyi</div><br/>
                <div><Img src={Ola}/> Ola</div><br/>
                <div><Img src=""/> Tobi</div><br/>
                <div><Img src=""/> Anjola</div><br/>
            </Div>
    
            
        </div>
  )
}

export default Lionhearts

const Img = styled.img`
height: 300px;
width: 300px;
@media screen and (max-width: 750px) {
  height: 150px;
  width: 150px;
}
`

const Div = styled.div`
font-size: 20px;
font-weight: bold;
`